<template>
    <Wrapper>
        <div class="flex-fill">
            <div class="row mb-3">
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-0 h-100 shadow-sm wow zoomIn">
                        <div class="row h-100 no-gutters bg-white rounded flex-nowrap">
                            <div class="col-auto bg-success rounded-left">&nbsp;</div>
                            <div class="col p-3 py-4 text-success">
                                <h6 class="text-truncate text-uppercase">Calls</h6>
                                <h3 class="text-nowrap">210</h3>
                            </div>
                            <div class="col-auto d-flex text-success">
                                <h1 class="mb-0 mx-auto align-self-center">
                                <a href="/" class="nav-link text-success pb-0" title="View details"><span class="d-inline-block lnr lnr-phone"></span></a>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-0 h-100 shadow-sm wow zoomIn">
                        <div class="row h-100 no-gutters bg-white rounded flex-nowrap">
                            <div class="col-auto bg-danger rounded-left">&nbsp;</div>
                            <div class="col p-3 py-4 text-danger">
                                <h6 class="text-truncate text-uppercase">Sales</h6>
                                <h3>53</h3>
                            </div>
                            <div class="col-auto d-flex rounded-right">
                                <h1 class="mb-0 mx-auto align-self-center"><a href="/" class="nav-link text-danger pb-0" title="View details">
                                    <span class="d-inline-block lnr lnr-cart"></span></a>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block h-100 shadow-sm wow zoomIn">
                        <div class="row h-100 no-gutters bg-white rounded flex-nowrap">
                            <div class="col-auto bg-primary rounded-left">&nbsp;</div>
                            <div class="col p-3 py-4 text-primary">
                                <h6 class="text-truncate text-uppercase">Growth</h6>
                                <h3 class="text-nowrap">19%</h3>
                            </div>
                            <div class="col-auto d-flex rounded-right">
                                <h1 class="mb-0 mx-auto align-self-center">
                                    <a href="/" class="nav-link pb-0 text-primary" title="View details">
                                        <span class="d-inline-block lnr lnr-rocket"></span>
                                    </a>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-0 h-100 shadow-sm wow zoomIn">
                        <div class="row h-100 no-gutters bg-white rounded flex-nowrap">
                            <div class="col-auto bg-info rounded-left">&nbsp;</div>
                            <div class="col p-3 py-4 text-info">
                                <h6 class="text-truncate text-uppercase">Alerts</h6>
                                <h3>2</h3>
                            </div>
                            <div class="col-auto d-flex rounded-right">
                                <h1 class="mb-0 mx-auto align-self-center">
                                    <a href="/" class="nav-link text-info pb-0" title="View details"><i class="lnr lnr-alarm"></i></a>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-lg-6 pb-3 wow zoomIn">
                    <div class="card h-100 shadow-sm">
                        <div class="card-body p-xl-3 p-2 d-flex flex-column">
                            <h4 class="font-weight-light mb-3">Revenue</h4>
                            <div class="my-auto p-1 py-2">
                                <LineChart :data="lineChartData" :options="lineChartOptions" height="300"  />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 pb-3 wow zoomIn">
                    <div class="card h-100 shadow-sm">
                        <div class="card-body p-xl-3 p-2 d-flex flex-column">
                            <h4 class="font-weight-light mb-3">Products</h4>
                            <div class="my-auto p-1 py-2">
                                <BarChart :options="barChartOptions" height="300" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 py-3">
                    <SliderProfile containerClasses="card shadow-sm rounded-lg h-100" />
                </div>
                <div class="col-xl-6 py-3">
                    <SliderContent containerClasses="card shadow-sm rounded-lg h-100" />
                </div>
                <div class="col-xl-6 py-3">
                    <div class="card h-100 shadow-sm wow fadeInUp" data-wow-delay=".5s">
                        <div class="card-body">
                            <div class="h4 m-0">
                                <i class="float-right lnr lnr-gift"></i>
                                Earnings
                            </div>
                            <div>up 15%</div>
                            <div class="progress my-3">
                                <div role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" class="progress-bar bg-primary w-75"></div>
                            </div> <small class="text-muted"><a href="#modalSmall" data-toggle="modal">Updated 5 mins ago</a></small></div>
                    </div>
                </div>
                <div class="col-xl-6 py-3">
                    <div class="card h-100 shadow-sm wow fadeInUp">
                        <div class="card-body">
                            <div class="h4 m-0">
                                <i class="float-right lnr lnr-sync"></i>
                                Pending
                            </div>
                            <div>Transfers in progress...</div>
                            <div class="progress my-3">
                                <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar bg-primary w-25"></div>
                            </div> <small class="text-muted">Estimated time remaining: 3.34 hrs</small></div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </Wrapper>
</template>
<script>
import { Wrapper, LineChart, BarChart, SliderContent, SliderProfile } from '../../components';

export default {
    components: {
        Wrapper,
        LineChart,
        BarChart,
        SliderContent,
        SliderProfile
    },
    data() {
        return {
            lineChartOptions: {
              responsive: true,
              maintainAspectRatio: false,
              legend: {display:false},
              title: {display:false},
              elements: {
                line: {
                    fill: false
                },
                point: {
                    radius: 5
                }
              },
              scales: {
                yAxes: [{
                  display: true,
                  ticks: {
                    beginAtZero: false,
                    stepValue: 10,
                    maxTicksLimit: 10
                  }
                }]
              }
            },
            lineChartData: {
              labels: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "June",
                "July",
                "Aug",
                "Sep",
                "Oct"
              ],
              datasets: [
                {
                  label: "Outsourced",
                  fill: true,
                  data: [
                    125,
                    105,
                    145,
                    125,
                    165,
                    145,
                    185,
                    165,
                    205,
                    185
                  ]
                },
                {
                  label: "",
                  data: []
                },
                {
                  label: "Total",
                  data: [
                    220,
                    210,
                    240,
                    230,
                    260,
                    250,
                    280,
                    270,
                    300,
                    290
                  ]
                }]
            },
            barChartOptions: {
              responsive: true,
              maintainAspectRatio: false,
              legend:{display:false},
              scales: {
                yAxs: [{
                    display: true,
                    ticks: {
                      beginAtZero: false,
                      stepValue:2
                    }
                }]
              }
            },
        }
    }
};
</script>
